import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ArticlePage from "../pages/article/page";
import ComparisonPage from "../pages/comparison/page";
import BeginnersPage from "../pages/beginners/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/mulebuy-spreadsheet-complete-guide",
    element: <ArticlePage />,
  },
  {
    path: "/mulebuy-spreadsheet-comparison",
    element: <ComparisonPage />,
  },
  {
    path: "/mulebuy-spreadsheet-beginners",
    element: <BeginnersPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;